// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 办理确认或验收普通任务 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/processTask/v1/command */
export async function executeBossProcessTaskCommand(
  body: CoreAPI.ActivityProcessTaskCommand,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessCommandResult>(
    '/bossApi/conference/core/processTask/v1/command',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询获授权任务及材料 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/processTask/v1/get */
export async function getBossProcessTask(
  body: CoreAPI.ActivityProcessTaskRefRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessTaskDetail>(
    '/bossApi/conference/core/processTask/v1/get',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
